<template>
    <v-container fluid>
        <v-card>
            <v-card-title class="headline indigo--text">
                Ingreso de pagos
            </v-card-title>

            <v-card-text>
                <!-- Layout principal: tabla de multas a la izquierda, formulario de ingreso a la derecha -->
                <v-layout row wrap>
                    <!-- IZQUIERDA: Tabla de Multas Asociadas al Contrato -->
                    <v-flex xs12 md7>
                        <v-card flat>
                            <v-toolbar color="white" flat>
                                <v-toolbar-title class="grey--text">
                                    Multas Asociadas
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-data-table v-model="selectedMultas" :headers="headersMultas" :items="itemsMultas"
                                :loading="loadingMultas" class="elevation-1" no-data-text="No hay multas disponibles"
                                select-all item-key="id">
                                <template v-slot:items="props">
                                    <td>
                                        <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                                    </td>
                                    <td class="text-xs-left">{{ props.item.periodo }}</td>
                                    <td class="text-xs-left">{{ props.item.productoReporte }}</td>
                                    <td class="text-xs-left">{{ props.item.fechaMulta }}</td>
                                    <td class="text-xs-left">{{ props.item.monto }}</td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-flex>

                    <!-- Separador opcional -->
                    <v-flex xs12 md1></v-flex>

                    <!-- DERECHA: Formulario de Ingreso de Pago -->
                    <v-flex xs12 md4>
                        <v-card flat>
                            <v-card-text>
                                <!-- Select Contrato -->
                                <v-select v-model="idContratoValue" :items="idContratoSelect" label="Contrato"
                                    item-text="nombre" item-value="code" @change="onContratoChange"></v-select>

                                <!-- Proveedor (solo lectura) -->
                                <v-text-field v-model="proveedorValue" label="Proveedor" readonly box></v-text-field>

                                <!-- Items (solo lectura) -->
                                <v-text-field v-model="itemsValue" label="Items" readonly box></v-text-field>
                                
                                <!-- Nro de Factura -->
                                <v-text-field v-model="nroPagoValue" label="Nro de Factura"></v-text-field>

                                <!-- Fecha de Pago -->
                                <v-menu v-model="menuFecha" :close-on-content-click="false"
                                    transition="scale-transition" offset-y full-width min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="fechaValue" label="Fecha Pago" prepend-icon="event"
                                            readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="fechaValue" @input="menuFecha = false" no-title locale="es"
                                        first-day-of-week="1"></v-date-picker>
                                </v-menu>

                                <!-- Monto de Pago: Solo lectura, se llena con la suma de los montos de las multas seleccionadas -->
                                <v-text-field v-model="computedPagoValue" label="Monto de pago $" type="number"
                                    readonly></v-text-field>

                                <!-- Observación -->
                                <v-textarea v-model="observacionValue" label="Observación asociada al pago"
                                    maxlength="500"></v-textarea>

                                <!-- Campo para subir archivo usando input nativo -->
                                <div class="my-2">
                                    <label for="file-upload" style="font-weight: 500; display: block;">
                                        Adjuntar Archivo
                                    </label>
                                    <input type="file" id="file-upload" name="file-upload" :accept="tipeArchive"
                                        @change="onFileChange($event)" style="display: block;" />
                                </div>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" dark @click="savePago" :disabled="btnSubmit">
                                    Guardar
                                    <v-icon right dark>save</v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios";
import jwtDecode from "jwt-decode";

export default {
    name: "IngresoPagos",
    data() {
        return {
            // Encabezados para la tabla de Multas Asociadas
            headersMultas: [
                { text: "Periodo", align: "left", sortable: false, value: "periodo" },
                { text: "Producto", sortable: false, value: "productoReporte" },
                { text: "Fecha", sortable: false, value: "fechaMulta" },
                { text: "Monto", sortable: false, value: "monto" }
            ],
            itemsMultas: [],
            loadingMultas: false,
            selectedMultas: [], // Array para las multas seleccionadas

            // Select Contrato
            idContratoSelect: [],
            idContratoValue: null,

            // Campos de solo lectura
            proveedorValue: "",
            itemsValue: "",

            // Fecha de Pago
            menuFecha: false,
            fechaValue: null,

            // Nro de Factura y Observación
            nroPagoValue: "",
            observacionValue: "",

            // Campo para subir archivo
            archivoBase64: "",

            // Control de guardado
            btnSubmit: false,
            // Tipos de archivo permitidos
            tipeArchive: ".pdf,.doc,.jpg,.png"
        };
    },
    computed: {
        computedPagoValue() {
            // Suma de los montos de las multas seleccionadas.
            if (this.selectedMultas && this.selectedMultas.length > 0) {
                return this.selectedMultas.reduce((sum, multa) => sum + Number(multa.monto), 0);
            }
            return "";
        }
    },
    created() {
        const token = localStorage.getItem("token");
        const decoded = jwtDecode(token);
        const user = decoded.dto;
        if (user.tipo === "ADMINISTRADOR") {
            this.loadContratos();
        } else {
            this.loadContratosByIdUsuario(user.id);
        }
    },
    methods: {
        async loadContratos() {
            try {
                const body = {
                    servicio: null,
                    periodo: null,
                    proveedor: null,
                    estado: null,
                    subProceso: "",
                    idContrato: null,
                    proceso: null
                };
                const response = await axios.post("/contratos/filter", body);
                this.idContratoSelect = response.data.map(p => ({
                    nombre: p.codigo,
                    code: p.id
                }));
            } catch (error) {
                console.error("Error al cargar contratos:", error);
            }
        },
        async loadContratosByIdUsuario(userId) {
            try {
                const body = { userId: userId };
                const response = await axios.post("/contratos/usuarios/filter", body);
                console.log("Contratos por usuario:", response.data);
                this.idContratoSelect = response.data.map(p => ({
                    nombre: p.codigo,
                    code: p.id
                }));
            } catch (error) {
                console.error("Error al cargar contratos:", error);
            }
        },
        async onContratoChange() {
            if (!this.idContratoValue) return;
            await this.loadContratoDetalle();
            this.loadMultasPrevias();
        },
        async loadContratoDetalle() {

            console.log("ID del contrato seleccionado:", this.idContratoValue);
            try {

                // hacer un get contratos by id
                const response = await axios.get(`/contrato/${this.idContratoValue}`);

                //   const resp = await axios.post("/contratos/filter", body);
                console.log("Detalle del contrato:", response.data);
                if (response.data != null) {
                    const item = response.data;
                    this.proveedorValue = item.proveedor.razonSocial || "";
                    this.itemsValue = item.itemContrato || "";
                }
            } catch (error) {
                console.error("Error al cargar detalle del contrato:", error);
            }
        },
        async loadMultasPrevias() {
            if (!this.idContratoValue) return;
            this.loadingMultas = true;
            try {
                const body = {
                    idContrato: this.idContratoValue,
                    id: null,
                    periodo: null, // Corregido de "perido" a "periodo"
                    productoReporte: null,
                    estado: false
                };
                const response = await axios.post("/pagosMultas/multas", body);
                this.itemsMultas = response.data;
            } catch (error) {
                console.error("Error al cargar multas previas:", error);
            } finally {
                this.loadingMultas = false;
            }
        },
        onFileChange(e) {
            const file = e.target.files[0];
            if (!file) {
                this.archivoBase64 = "";
                return;
            }
            const reader = new FileReader();
            reader.onload = event => {
                const result = event.target.result;
                this.archivoBase64 = result.includes("base64,")
                    ? result.split("base64,")[1]
                    : result;
            };
            reader.readAsDataURL(file);
        },
        async savePago() {
            this.btnSubmit = true;
            try {
                const body = {
                    id: "",
                    idContrato: this.idContratoValue,
                    fechaPago: this.fechaValue ? this.fechaValue : null,
                    monto: this.computedPagoValue, // Se usa la suma calculada
                    nroPago: this.nroPagoValue,
                    proveedor: this.proveedorValue,
                    productoReporte: this.selectedMultas.map(m => m.productoReporte).join(", "),
                    observacion: this.observacionValue,
                    documento: this.archivoBase64,
                    multas: this.selectedMultas.map(m => ({ id: m.id })) // Enviamos los IDs de las multas seleccionadas
                };
                await axios.post("/pagosMultas/savePago", body);
                this.limpiarFormulario();
                if (this.idContratoValue) {
                    this.loadMultasPrevias();
                }
                window.getApp.$emit("APP_SAVE");
            } catch (error) {
                console.error("Error al guardar pago:", error);
                if (error.response) {
                    window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
                }
            } finally {
                this.btnSubmit = false;
            }
        },
        limpiarFormulario() {
            this.fechaValue = null;
            // El monto se calcula automáticamente, por lo que no se limpia manualmente.
            this.nroPagoValue = "";
            this.observacionValue = "";
            this.archivoBase64 = "";
            this.selectedMultas = [];
        }
    }
};
</script>

<style scoped>
/* Puedes agregar estilos personalizados aquí */
</style>